import { CSSProperties } from "react";
import styled from "styled-components";

import { useTheme } from "@hooks";
import { constants } from "@layout";

export const Container = styled.div`
  margin-left: 10%;
  margin-right: 10%;
  flex: 1;

  @media (max-width: 500px) {
    margin-left: ${constants.divPadding}px;
    margin-right: ${constants.divPadding}px;
  }

  @media (max-width: 700px) {
    margin-bottom: 120px;
  }
`;

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    page: {
      backgroundColor: theme.background,
      flex: 1,
      alignItems: "center",
      justifyContent: "center",
    },
    wrapper: {
      display: "flex",
      flex: 1,
      alignItems: "flex-start",
    },
  };

  return styles;
};
